<section class="select-language-container">
  <div class="row">
    @for (language of allLanguages(); track language._id) {
      <div class="col-6 col-md-4 col-lg-3 col-xl-3">
        <button
          class="card default-button"
          [class.active-card]="selectedLanguageCode() === language.code"
          (click)="selectLanguage(language.code).subscribe()"
          (keydown.enter)="selectLanguage(language.code).subscribe()"
          tabindex="0"
        >
          <div class="card-header">
            <p
              class="card-header-title"
              [class.primary-font-bold]="theme() === GbTheme.ThemeOne"
              [class.primary-font-semibold]="theme() === GbTheme.ThemeTwo"
            >
              {{ language.name }}
            </p>
            @if (theme() === GbTheme.ThemeOne) {
              <div class="radio-button-container">
                <input
                  type="radio"
                  name="language"
                  [id]="'language-' + language.code"
                  [checked]="selectedLanguageCode() === language.code"
                />
                <span class="checkmark"></span>
              </div>
            }
          </div>
          <p class="primary-font-regular card-description">{{ language.name }}</p>
        </button>
      </div>
    }
  </div>
</section>
